export default __webpack_public_path__ + "static/media/fashion.92736cb3.jpg";